<script>

import VDataTableCustom from "@/components/VDataTable/VDataTableCustom.vue";

export default {
    name: "VDataTableSessions",
    components: {
        VDataTableCustom,
    },
    inheritAttrs: false,
    data() {
        return {
            headers: [
                {
                    text: 'ID',
                    align: 'start',
                    sortable: true,
                    value: 'ID_PD.VALUE',
                    width: 100,
                    filterComponent: 'VDataTableCustomHeaderFiltersText',
                    tooltip: 'Идентификатор в системе учета ЕПС',
                },
                {
                    text: 'Сессия',
                    align: 'start',
                    sortable: true,
                    value: 'NAME',
                    filterComponent: 'VDataTableCustomHeaderFiltersText',
                },
                {
                    text: 'Дата / Время',
                    align: 'center',
                    sortable: true,
                    value: 'DATETIME_START.VALUE',
                    width: 200,
                    filterComponent: 'VDataTableCustomHeaderFiltersDate',
                },
                {
                    text: 'Сорт.',
                    align: 'right',
                    sortable: true,
                    value: 'SORT',
                    width: 140,
                    filterComponent: 'VDataTableCustomHeaderFiltersText',
                    tooltip: 'Сортировка',
                },
            ],
            sort: {
                by: ['DATETIME_START.VALUE', 'SORT'],
                desc: [false, false],
            },
        };
    },
}
</script>

<template>
    <v-data-table-custom
        v-bind="$attrs"
        v-on="$listeners"
        :headers="headers"
        :sort-by="sort.by"
        :sort-desc="sort.desc"
        :multi-sort="true"
        item-key="ID"
        permissions-by-module="forums"
    >
        <template v-slot:item.DATETIME_START.VALUE="{value, item}">
            {{ value | moment('DD.MM.Y') }}
            {{ value | moment('HH:mm') }}
            <template v-if="item.DATETIME_FINISH">
                - {{ item.DATETIME_FINISH?.VALUE | moment('HH:mm') }}
            </template>
        </template>
    </v-data-table-custom>
</template>

<style scoped lang="scss">

</style>
